
export const statistics = {
    methods: {
         //查询培训统计（按年度）
         async getTrainStatistics(params) {
          let { pageNum, pageSize, name,year } = params
            let res = await this.$http.get("/course/quota/statistics",{
              year:year,
              name: name ?? null,
              pageNum: pageNum ?? null,
              pageSize: pageSize ?? null
            });
            console.log(res);
            return res;
        },
   
    },
  };
  